import React, { useState, useEffect } from "react";
import { NavLink, useLocation } from "react-router-dom";
import "./NavMenu.css";

const NavMenu = () => {
  const location = useLocation();

  const [currentroute, setcurrentroute] = useState(location.pathname);

  useEffect(() => {
    setcurrentroute(location.pathname);
  }, [location]);

  return (
    <div className="NavMain">
      <nav className="navbar navbar-expand navbar-dark flex-column flex-md-row bd-navbar b-watcho">
        <a className="navbar-brand mr-0 mr-md-2" href="https://www.vzy.one/">
          <img src="/Images/Watcho_Logo.png" className="b-logo" alt="VZY" />
        </a>

        <div className="navbar-nav-scroll">
          <ul className="navbar-nav bd-navbar-nav flex-row">
            <li className="nav-item">
              <a
                className="nav-link"
                href="https://www.vzy.one/"
                target="_blank"
                rel="noreferrer"
              >
                Home
              </a>
            </li>

            {(currentroute.toLowerCase() === "/becomeourpartner" ||
              currentroute.toLowerCase() === "/") && (
              <li className="nav-item ">
                <NavLink
                  to="/BecomeOurPartner"
                  className={`nav-link ${currentroute.toLowerCase() === "/becomeourpartner" ? "active" : ""}`}
                >
                  Become our Partner
                </NavLink>
              </li>
            )}

            {/* {(currentroute.toLowerCase() === "/becomeswagcreator" ||
              currentroute.toLowerCase() === "/") && (
              <li className="nav-item ">
                <NavLink
                  to="/BecomeSwagCreator"
                  className={`nav-link ${currentroute.toLowerCase() === "/becomeswagcreator" ? "active" : ""}`}
                >
                  Become a Swag Creator
                </NavLink>
              </li>
            )} */}

            {/* {(currentroute.toLowerCase() === "/family-and-friends" ||
              currentroute.toLowerCase() === "/customer-info" ||
              currentroute.toLowerCase() === "/thankyou-page" ||
              currentroute.toLowerCase() === "/") && (
              <li className="nav-item ">
                <NavLink
                  to="/family-and-friends"
                  className={`nav-link ${currentroute.toLowerCase() === "/family-and-friends" || currentroute.toLowerCase() === "/customer-info" || currentroute.toLowerCase() === "/thankyou-page" ? "active" : ""}`}
                >
                  Family and Friends
                </NavLink>
              </li>
            )} */}
          </ul>
        </div>
      </nav>
    </div>
  );
};

export default NavMenu;
